import React from "react";
import "./Background.css";

export default function Background() {
  return (
    <div className="background-container">
      <div className="stars"></div>
      <div className="twinkling"></div>
    </div>
  );
}
